<template>
  <v-container fluid class="purchasereceipt-add-page mt-3 mx-1">
    <v-row>
      <v-col cols="12">
        <v-stepper v-model="step" class="transparent elevation-0">
          <v-card class="mb-5">
            <v-stepper-header >
              <v-stepper-step :complete="step > 1" step="1">Purchase Receipt</v-stepper-step>
              <v-divider></v-divider>
              <v-stepper-step :complete="step > 2" step="2">Items</v-stepper-step>
            </v-stepper-header>
          </v-card>

          <v-card>
            <v-stepper-items>
              <v-stepper-content step="1">
                <v-card>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <p class="text-h5">New Purchase Receipt</p>
                        <v-text-field
                          outlined
                          dense
                          readonly
                          persistent-hint
                          class="mb-4"
                          placeholder="Purchase Order"
                          single-line hint="Purchase Order"       
                          v-bind:value="purchaseorder.purchaseordernum + ':' + purchaseorder.purchaseordername"
                        >
                        </v-text-field> 
                    </v-col>
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="3">
                      <v-form>
                        <v-select
                          class="mb-4"
                          :items=purchasereceipttype
                          v-model="new_purchasereceipt.purchasereceipttype"
                          v-bind:error="errorindex == 0"
                          outlined
                          dense
                          placeholder="Type"
                          persistent-hint
                          single-line hint="Please choose the receipt type">
                        </v-select>
                        <v-menu
                          ref="new_purchasereceiptdate"
                          v-model="new_purchasereceiptdate"
                          :close-on-content-click="false"
                          :return-value.sync="new_purchasereceipt.purchasereceiptdate"
                          transition="scale-transition"
                          offset-y
                          min-width="auto"
                        >
                          <template v-slot:activator="{ on, attrs }">
                            <v-text-field
                              outlined
                              dense
                              v-model="new_purchasereceipt.purchasereceiptdate"
                              label="Receipt Date"
                              v-bind="attrs"
                              v-bind:value="new_purchasereceipt.purchasereceiptdate"
                              v-bind:error="errorindex == 1"
                              v-on="on"
                              single-line hint="Please choose the receipt date">
                            ></v-text-field>
                          </template>
                          <v-date-picker
                            v-model="new_purchasereceipt.purchasereceiptdate"
                            no-title
                            scrollable
                          >
                            <v-spacer></v-spacer>
                            <v-btn
                              text
                              color="primary"
                              @click="new_purchasereceiptdate = false"
                            >
                              Cancel
                            </v-btn>
                            <v-btn
                              text
                              color="primary"
                              @click="$refs.new_purchasereceiptdate.save(new_purchasereceipt.purchasereceiptdate)"
                            >
                              OK
                            </v-btn>
                          </v-date-picker>
                        </v-menu>
                      </v-form>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-form>
                        <v-select
                          class="mb-4"
                          :items="locations.map(x => {return {text: x.locationname, value: x._id};})"
                          v-model="new_purchasereceipt.locationid"
                          v-bind:error="errorindex == 2"
                          outlined
                          dense
                          placeholder="Location"
                          persistent-hint
                          single-line hint="Please choose the location">
                        </v-select>
                        <v-textarea
                          v-model="new_purchasereceipt.purchasereceiptnote"
                          outlined
                          rows=3
                          label="Note"
                          hint="please enter the note"
                        ></v-textarea>
                      </v-form>
                    </v-col>                                        
                  </v-row>
                  <v-row justify="center">
                    <v-col cols="12" md="6">
                      <div class="d-flex justify-center">
                        <v-btn
                            to="/purchaseorder/list"
                            replace
                            outlined
                            color="primary"
                        >
                          Cancel
                        </v-btn>
                        <v-spacer></v-spacer>
                          <v-btn
                            class="button-shadow"
                            color="primary"
                            @click="checkError">
                            Next
                          </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
              <v-stepper-content step="2">
                <v-card>
                  <v-data-table
                    :headers="itemHeaders1"
                    :items="transactions"
                    :items-per-page="100"
                    :footer-props="{'items-per-page-options': [500, 1000, 5000]}"
                    class="elevation-0"
                  >
                  <template v-slot:item.receiveQty="{ item }">
                    <div style="margin-top: 35px; margin-bottom: 0; align-content: center;">
                      <v-text-field
                      outlined
                      dense
                      persistent-hint
                      class="mb-4"
                      placeholder="Qty"  
                      type="number"
                      v-model="item.receiveQty"
                      oninput="if(this.value < 1) this.value = 1;"
                    >
                    </v-text-field>            
                    </div>
                  </template>
                  <template v-slot:item.itemimage="{ item }"> 
                      <v-img
                        v-bind:lazy-src="item.itemimage"
                        min-width=60
                        max-width=60
                        v-bind:src="item.itemimage"
                      ></v-img>
                    </template>
                    <template v-slot:item.itemname="{ item }"> 
                      {{ item.itemname }}
                    </template>
                    <!-- <template v-slot:item.receipts="{ item }"> 
                      {{ item.receipts.reduce(function (last, json) {return last + json.receiveQty}, 0) }}
                    </template> -->
                  </v-data-table>
                  <v-row justify="center">
                    <v-col cols="12" md="12">
                      <div class="d-flex justify-center">
                        <v-btn
                          outlined
                          color="primary"
                          @click="step = 1"
                        >
                          Back
                        </v-btn>
                        <v-spacer></v-spacer>
                        <v-btn
                          :loading="isReceiving"
                          class="button-shadow"
                          color="primary"
                          @click="insertPurchaseReceipt()">
                          Save
                        </v-btn>
                      </div>
                    </v-col>
                  </v-row>
                </v-card>
              </v-stepper-content>
            </v-stepper-items>
          </v-card>
        </v-stepper>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import {mapActions, mapState} from "vuex";
import router from '@/Routes';

export default {
  data () {
    return {
      itemHeaders1: [
        { text: 'Image', value: 'itemimage' , width: '7%'},
        { text: 'Name', value: 'itemname' },
        { text: 'Cost', value: 'itemcost', width: '10%'},
        { text: 'Order Qty', value: 'itemquantity', width: '10%'},
        { text: 'Rcvd Qty', value: 'receivedQty', width: '10%'},
        { text: 'Receive', value: 'receiveQty', width: '10%'},
      ],
      transactions: [],
      step: 1,
      new_purchasereceipt: {},
      purchaseorder: {},
      new_purchasereceiptdate: false,
      purchasereceipttype: ['Purchase Receipt'],
      error: undefined,
      errortag: false,
      errorindex: undefined,
    }
  },
  computed: {
    ...mapState('Item', ['items']),
    ...mapState('Location', ['locations']),
    ...mapState('PurchaseReceipt', ['isReceiving']),
  },
  methods: {
    ...mapActions('Item', ['getItemsRequest']),
    ...mapActions('Location', ['getLocationsRequest']),
    ...mapActions('PurchaseReceipt', ['insertPurchaseReceiptRequest']),
    checkError(){
      // if(this.new_purchasereceipt!==null) {this.errortags=false; return true;}
      // if(!this.new_purchasereceipt.purchasereceipttype){
      //   this.errortags = true;
      //   this.errorindex = 0;
      //   return false;
      // }
      // if(!this.new_purchasereceipt.purchasereceiptdate){
      //   this.errortags = true;
      //   this.errorindex = 1;
      //   return false;
      // }
      // if(!this.new_purchasereceipt.locationid){
      //   this.errortags = true;
      //   this.errorindex = 2;
      //   return false;
      // }
      this.errorindex = -1;
      this.step = 2;
      return true;
    },
    async insertPurchaseReceipt() {
      this.new_purchasereceipt.purchaseorderid = this.purchaseorder._id;
      let payload = {purchasereceipt: this.new_purchasereceipt, transactions: this.transactions};
      await this.insertPurchaseReceiptRequest(payload);
      router.push('/purchasereceipt/list');
    },
    getReceived(itemid){
      let trans = this.purchaseorder.receipts.filter(receipt=>receipt.itemid==itemid);
      let result = trans.reduce((a,b)=>a+b.receiveQty, 0);
      return result;
    }
  },

  async created () {
    this.purchaseorder = this.$route.params;
    this.new_purchasereceipt.vendorid = this.purchaseorder.vendorid;
    this.new_purchasereceipt.locationid = this.purchaseorder.locationid;
    if (!this.purchaseorder._id) this.$router.push({ name: "PurchaseOrderList" });
    this.transactions = this.purchaseorder.transactions.map(trans=>{
      return {
        itemid: trans.itemid,
        itemname: trans.itemname,
        itemimage: trans.itemimage,
        itemquantity: trans.itemquantity,
        itemcost: trans.itemcost,
        receivedQty: this.getReceived(trans.itemid),
        balanceQty: trans.itemquantity - this.getReceived(trans.itemid),
        receiveQty: 0
      }
    });
    if(this.items.length==0) await this.getItemsRequest();
    if(this.locations.length==0) await this.getLocationsRequest();
  }
}
</script>

<style src="./Add.scss" lang="scss"></style>
